import { render, staticRenderFns } from "./MatterCautionForm.vue?vue&type=template&id=67a38421&"
import script from "./MatterCautionForm.vue?vue&type=script&lang=js&"
export * from "./MatterCautionForm.vue?vue&type=script&lang=js&"
import style0 from "./MatterCautionForm.vue?vue&type=style&index=0&id=67a38421&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports